



















import { Component, Vue, Prop } from 'vue-property-decorator';
import debounce from 'lodash.debounce';
import { SitesApi, Site } from '../api';
import { Validation } from 'vuelidate';
import { VueSelect } from 'vue-select';

@Component({
	components: { VueSelect },
})
export default class SitePicker extends Vue {
	// computed
	get validationState() {
		if (this.validator) {
			return this.validator.$dirty && this.validator.$invalid;
		}
		return null;
	}

	@Prop(Object)
	public value?: object;

	@Prop(Object)
	public readonly validator?: Validation;

	@Prop(Boolean)
	public readonly disabled?: boolean;

	public options: Site[] = [];
	private api: SitesApi;

	constructor() {
		super();
		this.api = new SitesApi();
		this.debouncedOptions = debounce(this.fetchOptions, 100);
	}

	public onSelect(item: any) {
		if (this.validator) {
			this.validator.$touch();
		}
		this.$emit('input', item);
	}

	public onSearch(search: string, loading: any) {
		// if (!search || search.length < 3) {
		if (!search) {
			this.debouncedOptions.cancel();
			loading(false);
			return;
		}
		this.debouncedOptions.cancel();
		loading(true);
		this.debouncedOptions(search, loading);
	}

	public async fetchOptions(search: string, loading: any) {
		loading(true);

		const options = {
			params: {
				'filter[name]': search,
				'fields[sites]': 'id,name',
			},
		};
		const response = await this.api.getSites(options);
		this.options = response.data.data || [];
		loading(false);
	}

	private readonly debouncedOptions: any = () => {
		return [];
	};
}
